module.exports = __webpack_public_path__ + "img/hisha.1d0f1fc1.png";